import type { IconType } from '@/frontend-types'
import type { TimelineBlock as TimelineBlockType } from '@/payload-types'
import type { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core'
import type { SerializedBlockNode } from '@payloadcms/richtext-lexical'
import type { JSXConverter } from '@payloadcms/richtext-lexical/react'
import { CMSBlocks } from '../atoms/CMSBlocks'
import type { TimelinePhaseType } from '../atoms/TimelinePhase'
import { TimelineBlock } from '../blocks/TimelineBlock'

export const TimelineConverter: JSXConverter<SerializedBlockNode<TimelineBlockType>> = ({
	node,
	nodesToJSX,
}) => {
	const { milestones } = node.fields

	const phasesData: TimelinePhaseType[] = []

	if (!milestones) {
		return null
	}

	for (const phase of milestones) {
		const { status, faPrefix, faIcon } = phase

		const iconName = faIcon as IconName
		const iconPrefix = faPrefix as IconPrefix

		const icon: IconType = [iconPrefix, iconName]

		const phaseData: TimelinePhaseType = {
			id: phase.id,
			status,
			icon,
			content: <CMSBlocks>{nodesToJSX({ nodes: phase.content?.root?.children ?? [] })}</CMSBlocks>,
		}

		phasesData.push(phaseData)
	}

	return <TimelineBlock timeline={phasesData} />
}
